/**
 * Created by augustocorvalan on 7/17/15.
 */
'use strict';

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var SoaModel = require('bunsen/models/SoaModel');
var AnchorMember = module.exports = SoaModel.extend();
var Anchor = require('bunsen/models/Anchor');
var SoaCollection = require('bunsen/collections/SoaCollection');

_.extend(AnchorMember, {
    createAnchorMembers: function (sourceType, ids, note) {
        return new SoaCollection(_.map(ids, function (id) {
            if (_.isString(id)) {
                id = id.trim();
            }

            return new AnchorMember({
                'anchor': new Anchor({
                    apiType: 'anchor',
                    sourceId: id,
                    sourceType: sourceType
                }),
                note: note
            });
        }));
    }
});

_.extend(AnchorMember.prototype, {
    defaults: {
        'apiType': 'anchorListMember'
    },
    relations: SoaModel.createRelations([
        {
            key: 'anchor',
            type: Backbone.One,
            relatedModel: Anchor
        }
    ])
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/AnchorMember.js
// module id = 80
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54